module.exports = __webpack_public_path__ + "img/365challenge.fdbc9e6b.png";